import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import LuckyDrawService from "../../services/luckydraw.service";

/* GET ACTIVE LUCKY DRAW */

export const getLuckyDraws = createAsyncThunk(
  "luckydraw/getLuckyDraws",
  async (item, thunkApi) => {
    try {
      const response =
        await LuckyDrawService.getLuckyDraw(item);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const myluckydraw = createAsyncThunk(
  "luckydraw/myluckydraw",
  async (item, thunkApi) => {
    try {
      const response =
        await LuckyDrawService.myluckydraw(item);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const addLuckydraw = createAsyncThunk(
  "addluckydraw/addLuckydraw",
  async (item, thunkAPI) => {
    try {
      const response = await LuckyDrawService.addLuckydraw(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getUserLuckyDraws = createAsyncThunk(
  "userluckydraw/getUserLuckyDraws",
  async (item, thunkApi) => {
    try {
      const response =
        await LuckyDrawService.getUserLuckyDraw(item);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const getluckydrawentries = createAsyncThunk(
  "luckydraw/getluckydrawentries",
  async (item, thunkApi) => {
    try {
      const response =
        await LuckyDrawService.getluckydrawentries(item);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

/* APPROVE LUCKY DRAW ENTRY */

export const approveluckydrawentry =
  createAsyncThunk(
    "luckydraw/approveluckydrawentry",
    async (item, thunkApi) => {
      try {
        const response =
          await LuckyDrawService.approveluckydrawentry(
            item
          );

        return response.data;
      } catch (error) {
        return thunkApi.rejectWithValue(
          error.response?.data?.message ||
          error.message
        );
      }
    }
  );


export const JoinLuckyDraw =
  createAsyncThunk(
    "joinluckydraw/joinluckydraw",
    async (item, thunkApi) => {
      try {
        const response =
          await LuckyDrawService.JoinLuckyDraw(
            item
          );

        return response.data;
      } catch (error) {
        return thunkApi.rejectWithValue(
          error.response?.data?.message ||
          error.message
        );
      }
    }
  );

const initialState = {
  loading: false,
  error: "",

  luckyDraws: [],


  joined: false,
  paymentStatus: null,

  pagination: null,
};

const luckyDrawSlice = createSlice({
  name: "luckyDraw",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      /* GET LUCKY DRAW */

      .addCase(
        getLuckyDraws.pending,
        (state) => {
          state.loading = true;
          state.error = "";
        }
      )

      .addCase(
        getLuckyDraws.fulfilled,
        (state, action) => {
          state.loading = false;

          // Convert object -> array
          state.luckyDraws = action.payload?.data
            ? [action.payload.data]
            : [];

          state.joined =
            action.payload?.joined || false;

          state.paymentStatus =
            action.payload?.paymentStatus ||
            null;
        }
      )

      .addCase(
        getLuckyDraws.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      )


      // add
      .addCase(addLuckydraw.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addLuckydraw.fulfilled, (state, action) => {
        state.loading = false;
        const newLuckydraw =
          action.payload?.data ||
          action.payload?.luckyDraws ||
          action.payload;

        if (newLuckydraw) {
          state.luckyDraws.unshift(newLuckydraw);
        }
      })
      .addCase(addLuckydraw.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      /* GET LUCKY DRAW */

      .addCase(
        getUserLuckyDraws.pending,
        (state) => {
          state.loading = true;
          state.error = "";
        }
      )

      .addCase(
        getUserLuckyDraws.fulfilled,
        (state, action) => {
          state.loading = false;

          // Convert object -> array
          state.luckyDraws = action.payload?.data
            ? [action.payload.data]
            : [];

          state.joined =
            action.payload?.joined || false;

          state.paymentStatus =
            action.payload?.paymentStatus ||
            null;
        }
      )

      .addCase(
        getUserLuckyDraws.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      )



      /* APPROVE ENTRY */

      .addCase(
        approveluckydrawentry.pending,
        (state) => {
          state.loading = true;
          state.error = "";
        }
      )

      .addCase(
        approveluckydrawentry.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        approveluckydrawentry.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export default luckyDrawSlice.reducer;